import { render, staticRenderFns } from "./brand-native.vue?vue&type=template&id=209a1314"
import script from "./brand-native.vue?vue&type=script&lang=js"
export * from "./brand-native.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports